import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Actions, ApiEndpoints} from '../constants/ApiEndpoints';
import {RequestMethod, RestService} from './rest.service';
import {environment} from '../../../environments/environment';
import {PaymentMethod, PaymentMethodsResponse, SetupIntentResponse} from '../models/account/payment-method';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {

  private readonly baseUrl = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}`;

  constructor(private restService: RestService) {
  }

  getPaymentMethods(): Observable<PaymentMethodsResponse> {
    const url = `${this.baseUrl}/${Actions.BASE_ACTIONS.READ}/payment_methods`;
    return this.restService.restRequest<any>(RequestMethod.GET, url).pipe(
      map(response => response.data as PaymentMethodsResponse)
    );
  }

  createSetupIntent(type: 'card' | 'us_bank_account' | 'all' = 'all'): Observable<SetupIntentResponse> {
    const url = `${this.baseUrl}/${Actions.BASE_ACTIONS.UPDATE}/setup_intent`;
    return this.restService.restRequest<any>(RequestMethod.POST, url, {
      body: {type}
    }).pipe(
      map(response => response.data as SetupIntentResponse)
    );
  }

  setDefault(paymentMethodId: string): Observable<any> {
    const url = `${this.baseUrl}/${Actions.BASE_ACTIONS.UPDATE}/set_default`;
    return this.restService.restRequest(RequestMethod.PUT, url, {
      body: {paymentMethodId}
    });
  }

  delete(paymentMethodId: string): Observable<any> {
    const url = `${this.baseUrl}/${Actions.BASE_ACTIONS.DELETE}/payment_method`;
    return this.restService.restRequest(RequestMethod.DELETE, url, {
      body: {paymentMethodId}
    });
  }
}
